// Constantes de motivos de drop/reprovação compartilhadas entre os modais
import { FreelancerStatus } from "@/types/freelancer-rating";

// Motivos gerais de reprovação
export const MOTIVOS_GERAIS = [
  "Perfil não adequado",
  "Valor acima do orçamento",
  "Falta de experiência específica",
  "Não respondeu contato",
  "Desistiu do processo",
  "Cliente rejeitou portfólio",
  "Cliente rejeitou perfil",
  "Outro",
] as const;

// Motivos relacionados a status de disponibilidade (negativos)
export const MOTIVOS_STATUS = [
  { motivo: "Indisponível", status: "indisponivel" as FreelancerStatus },
  { motivo: "Temporariamente Indisponível", status: "temporariamente_indisponivel" as FreelancerStatus },
] as const;

// Combinação de todos os motivos
export const TODOS_MOTIVOS = [
  ...MOTIVOS_STATUS.map(m => m.motivo),
  ...MOTIVOS_GERAIS,
] as const;

export type MotivoDropType = typeof TODOS_MOTIVOS[number];

